<template>
  <div  style="position: absolute;left: 0; top: 0; background-color: #f3f3f3; z-index: 1500;">
    <div class="d-flex align-items-center justify-content-center" id="cont_main">
      <div class="wraper col-md-8">
        <div class="logo-wraper ">
            <div class="logo d-flex align-items-center justify-content-center ">
              <img  src="../assets/pictures/me_big.png" alt="branding logo" @click="$router.push({ name: 'login'});">
            </div>
        </div>        
        <div class="form-wraper d-flex align-items-center justify-content-center" >
          <div class="form-content col-md-8">
              <div>
                <div class="lang-swicher">
                  <ul class="nav navbar-nav float-xs-right"> 
                    <li class="dropdown dropdown-language nav-item">
                    <a id="dropdown-flag" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="dropdown-toggle nav-link">
                      <!-- <i ref="lang_btn" class="flag-icon" :class="$i18n.tc('lang.logo', $i18n.locale )"></i> -->
                      <span class="selected-language"> {{$i18n.tc('lang.titleS', $i18n.locale )}}</span>
                    </a>                
                    <div aria-labelledby="dropdown-flag" class="dropdown-menu">
                      <a class="dropdown-item" @click="changeLanguage('ua')">UA </a>
                      <a class="dropdown-item" @click="changeLanguage('pl')">Pl</a>
                      <a class="dropdown-item" @click="changeLanguage('en')">EN </a>                  
                      <a class="dropdown-item" @click="changeLanguage('ru')">RU</a>                      
                    </div>
                  </li>
                  </ul>
                </div>

                <div class="title my-2">
                  <h3>{{$t('titles.recoverPassword')}}</h3>
                </div>
              </div>              
              <div class="login-form ">               

                  <div class="card-body collapse in" v-if="!showBlock">
                      <div class="card-block">
                          <div class="form-horizontal form-simple">

                            <fieldset class="form-group position-relative has-icon-left mb-otstup" :class="{ 'form-group--error': $v.mail.$error }">
                                <input type="text" v-model.trim="$v.mail.$model" v-on:keyup.enter="sendRecover()" class="form-control form-control-lg input-lg" :placeholder="$t('registr.lbl.email')" required>
                                <div class="form-control-position">
                                    <i class="icon-email"></i>
                                </div>
                                <div class="error" v-if="!$v.mail.required">{{$t('errors.required')}}</div>
                                <div class="error" v-if="!$v.mail.email">{{$t('errors.email')}}</div>
                            </fieldset>

                            <button type="button" class="btn btn-auth btn-lg btn-block"  @click="sendRecover()">
                              <i class="icon-envelop"></i> {{ $t('titles.recoverPassword') }}
                            </button>                            

                          </div>
                      </div>
                  </div>
                  <div class="card-body collapse in" v-if="showBlock">
                      <div class="card-block">
                          <div class="form-horizontal form-simple">

                            <fieldset class="form-group position-relative has-icon-left mb-otstup" :class="{ 'form-group--error': $v.newpass.newPass1.$error }">
                                <input type="password" v-model.trim="$v.newpass.newPass1.$model" v-on:keyup.enter="sendChangePasswReq()" class="form-control form-control-lg input-lg" :placeholder="$t('profile.table.newPass')" required>
                                <div class="form-control-position">
                                    <i class="icon-key3"></i>
                                </div>
                                <div class="error" v-if="!$v.newpass.newPass1.required">{{$t('errors.required')}}</div>
                                <div class="error" v-if="!$v.newpass.newPass1.minLength">{{$t('errors.minLength')}} {{$v.newpass.newPass1.$params.minLength.min}}</div>
                            </fieldset>

                            <fieldset class="form-group position-relative has-icon-left mb-otstup" :class="{ 'form-group--error': $v.newpass.newPass2.$error }">
                                <input type="password" v-model.trim="$v.newpass.newPass2.$model" v-on:keyup.enter="sendChangePasswReq()" class="form-control form-control-lg input-lg" :placeholder="$t('registr.lbl.confirmPass')" required>
                                <div class="form-control-position">
                                    <i class="icon-key3"></i>
                                </div>
                                <div class="error" v-if="!$v.newpass.newPass2.required">{{$t('errors.required')}}</div>
                                <div class="error" v-if="!$v.newpass.newPass2.minLength">{{$t('errors.minLength')}} {{$v.newpass.newPass2.$params.minLength.min}}</div>
                            </fieldset>

                            <button type="button" class="btn btn-success btn-lg btn-block"  @click="sendChangePasswReq()">
                              <i class="icon-envelop"></i> {{$t('profile.buttons.save')}}
                            </button>                            

                          </div>
                      </div>
                  </div>



              </div>
              <div class="register mb-3 d-flex justify-content-end"> 
                  <button type="button" class="btn btn-outline-secondary btn-md" @click="$router.push({name: 'login'})">{{ $t('login.btn.login') }}</button>
                </div>            
          </div>          
        </div>
      </div>   
    </div>
  </div>
</template>

<script>
import { sameAs, required, minLength,  email } from 'vuelidate/lib/validators'
    export default {
      name: "LoginNew",
      components: {},
      data() {
          return { 
            errors: [],
            submitStatus: null,
            mail: null,
            token:null,
            showBlock: false,
            newpass: {              
              newPass1: null,
              newPass2: null,
            }
            
          }
        },
        validations() {
          if (!this.showBlock){
            return {mail:{ required, email }}
          } 
          else return {
              newpass:{
                newPass1:{ required, minLength: minLength(6) },
                newPass2:{ required, minLength: minLength(6) }
              },
          }
        },
        methods: {
          sendRecover() {
            this.$v.$touch();
                        
            if (this.$v.$invalid) {
              this.submitStatus = 'ERROR';
            }
             else {
              let dataRequest = {
                email: this.mail
              };
               console.log("send req"+ dataRequest);
               this.makeQuery("/portal/recoveryPassword", {dataRequest: dataRequest})
              .then(result => {
                if (result.data.result)
                {
                  this.showNotification('custom-success','Recovering', result.data.data);
                  this.$router.push({ name: 'login'});
                }
                  console.log(result);
                  
              });
            }
            
          
          },
          sendChangePasswReq(){
            this.$v.$touch();
            if (this.$v.$invalid) {
              this.submitStatus = 'ERROR';
            }
            else {
              let dataRequest = {
                passwordNew: this.newpass.newPass1,
                token: this.token
              };
               this.makeQuery("/portal/changePassword", {dataRequest: dataRequest})
              .then(result => {
                if(result.data.result){ 
                  this.showNotification('custom-success','Recovering',this.$t('titles.recoverPasswordSucces') );
                  this.$router.push({ name: 'login'});
                }
                else {
                  this.showNotification('custom-success','Recovering', result.data.data );
                }
              });
            }          
          }
              
        },
        computed:{
                     },
        watch:{},
        created() {
          console.log(this.$route);
          //token
          if ((this.$route.query.uid != undefined) && (this.$route.query.uid != null)){
            this.showBlock = true;
            this.token = this.$route.query.uid
            this.newpass.newPass1 = null;
            this.newpass.newPass2 = null;
          }
        },
        mounted () {
       
        }
    }
</script>

<style scoped>

.img_cont{
  max-width: 40%;
}
  #cont_main{
  background-image: url('../assets/pictures/bagr.jpg');
  background-color: rgba(255,255,255,0.5); 
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-attachment: fixed;
  width: 100vw;
  min-height: 100vh;
}

.form-wraper {
  background: #E5E5DB;
  width: 100%;  
}
.form-wraper .title {
  text-align: center;
}
.title h3 {
  font-weight: bold;
  font-size: 48px;
}
.selected-language {
    padding: 5px 5px;
    border: 1px solid #000;
}
.dropdown .dropdown-menu {
    min-width: 40px;
    background: #000;
    color: #fff;
}
.dropdown-item {
    color: #fff;
}
.dropdown-item:hover {
    color: #000;
}
a:not([href]):not([tabindex]):hover {
    color: #000;
}
.logo {
  margin-bottom: 40px;
  cursor: pointer;
}
.logo img {
  width: 30%;
}

.card-block {
  padding: 10px;
}
.form-control, .form-control-lg {
font-size: 1rem !important;
}
.btn-outline-secondary:hover {
  background-color: #000
}
.form-group--error .form__label, .form-group--error .form__label--inline, .form-group--error .label{
    color: #f04124; 
    display: block;
    }
  
  .form-group--error .form-group__addon {
    color: white;
    border-color: #f79483;
    background: #f79483; }
  
  .form-group--error input,
  .form-group--error textarea,
  .form-group--error input:focus,
  .form-group--error input:hover {
    border-color: #f79483; }
  
  .form-group--error  .form-group__message, .form-group--error  .error  {
    display: block;
    color: #f57f6c; }
    .form-group--error label {    
    color: #f57f6c; }
@media only screen and (max-width: 800px) {
.inn {
   padding-left: 0px;
}
.ex-btn {
  display: block;
}
}
</style>


// WEBPACK FOOTER //
// src/pages/recover-password.vue